import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import SectionSidebar from '../../components/SectionSidebar';
import Card from '../../components/Card';
import { useCustomSnackbar } from '../../hooks/useCustomSneakbar';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';

const SectionDashboard = () => {
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosCommon = generateAxiosInstanceCommon()
    const [TeacherList, setTeacherList] = useState([])
    const [EditId, setEditId] = useState('')
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")
    const [openSuccessSnackbar] = useCustomSnackbar('success')
    const navigate = useNavigate();

    const [data, setData] = useState("");

    useEffect(() => {
        const apiUrl = `/all-dashboard-count?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
        authorizedAxiosCommon && authorizedAxiosCommon.get(apiUrl)
            .then(response => {
                setData(response.data.result)
                console.log('Data:', response.data.result);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }, []);

    // useEffect(() => {
    //     const apiUrl = `/get-app-registered-teacher?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
    //     authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
    //         .then(response => {
    //             setTeacherList(response.data.result)
    //             console.log('Data:', response.data);
    //         })
    //         .catch(error => {
    //             // Handle any errors that occurred during the request
    //             console.error('Error fetching data:', error);
    //             const errorMsg = error?.response?.data?.message || 'Something went wrong!';

    //         });

    // }, []);




    // const updateLesson = (editId) => {
    //     const apiUrl = `/approve-app-registered-teacher`;
    //     authorizedAxiosSection && authorizedAxiosSection.post(apiUrl, { teacherId: editId })
    //         .then(response => {
    //             // openSuccessSnackbar(response.data.message);
    //             Swal.fire(
    //                 { text: response.data.message }
    //             );
    //             console.log('Data:', response.data);
    //         })
    //         .catch(error => {
    //             // Handle any errors that occurred during the request
    //             console.error('Error fetching data:', error);
    //             const errorMsg = error?.response?.data?.message || 'Something went wrong!';
    //             Swal.fire(
    //                 { text: errorMsg }
    //             );
    //         });
    // }



    return (
        <>
            {/* <SectionSidebar /> */}
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item active">
                            <span>Dashboard</span>
                        </li>

                    </ol>
                </nav>
                <div className="body flex-grow-1 px-3">
                    <div className="container-lg">
                        <div className="row">


                            <div class="Dcard-container">
                                {/* <div class="Dcard" onClick={() => navigate('/section-register-teacher-list')}>
                                    <h2>Teacher  List</h2>
                                    <p>

                                    </p>
                                </div> */}

                                <div class="Dcard" onClick={() => navigate("/section-all-student-list")}>
                                    <i class="fa-solid fa-users-line"></i>
                                    <ul className='d-flex'>
                                        <li>
                                            <h4>Total No Of Student</h4>
                                            <div className='count'>{data?.sectionCounts?.sectionStudentCount?.activeStudent + data?.sectionCounts?.sectionStudentCount?.deActiveStudent}</div>
                                        </li>
                                        <li>
                                            <h4>Total No Of Active Student</h4>
                                            <div className='count'>{data?.sectionCounts?.sectionStudentCount?.activeStudent}</div>
                                        </li>
                                        <li>
                                            <h4>Total No Of Deactive Student</h4>
                                            <div className='count'>{data?.sectionCounts?.sectionStudentCount?.deActiveStudent}</div>
                                        </li>
                                    </ul>
                                    <div className='title'><h2>Student Count</h2></div>
                                </div>

                                <div class="Dcard" onClick={() => navigate('/section-register-teacher-list')}>
                                    <i class="fa-solid fa-person-chalkboard"></i>
                                    <ul className='d-flex'>
                                        <li>
                                            <h4>Total No Of Teacher</h4>
                                            <div className='count'>{data?.sectionCounts?.sectionTeacherCount?.activeTeacher + data?.sectionCounts?.sectionTeacherCount?.deActiveTeacher}</div>
                                        </li>
                                        <li>
                                            <h4>Total No Of Active Teacher</h4>
                                            <div className='count'>{data?.sectionCounts?.sectionTeacherCount?.activeTeacher}</div>
                                        </li>
                                        <li>
                                            <h4>Total No Of Deactive Teacher</h4>
                                            <div className='count'>{data?.sectionCounts?.sectionTeacherCount?.deActiveTeacher}</div>
                                        </li>
                                    </ul>
                                    <div className='title'><h2>Teacher List</h2></div>
                                </div>

                                <div class="Dcard" onClick={() => navigate('/section-dashboard-study-material')}>
                                    <i class="fa-solid fa-book"></i>
                                    <ul className='d-flex'>
                                        <li>
                                            <h4>Total No Syllabus Structure</h4>
                                            <div className='count'>{data?.sectionCounts?.sectionSyllabusStructureCount}</div>
                                        </li>
                                        <li>
                                            <h4>Total No Of Books </h4>
                                            <div className='count'>{data?.sectionCounts?.sectionPdfBookCount}</div>
                                        </li>
                                        <li>
                                            <h4>Total No Of Refrence Book</h4>
                                            <div className='count'>{data?.sectionCounts?.sectionReferenceBookCount}</div>
                                        </li>
                                        <li>
                                            <h4> Total No Of Video</h4>
                                            <div className='count'>{data?.sectionCounts?.sectionVideoCount}</div>
                                        </li>
                                    </ul>
                                    <div className='title'><h2>Study Material Count</h2></div>
                                </div>

                                {/* <div class="Dcard" onClick={() => navigate('/section-announcements-view')}>
                                    <h2>Announcements</h2>
                                    <p>

                                    </p>
                                </div> */}

                           

                                {/* <div class="Dcard" >
                                    <i class="fa-solid fa-users-line"></i>
                                    
                                    <div className='title'><h2>Card 2</h2></div>
                                </div>

                                <div class="Dcard" >
                                    <i class="fa-solid fa-users-line"></i>
                                    
                                    <div className='title'><h2>Card 3</h2></div>
                                </div>
                                <div class="Dcard" >
                                    <i class="fa-solid fa-users-line"></i>
                                    
                                    <div className='title'><h2>Card 4</h2></div>
                                </div> */}
                               
                              
                            </div>

                        </div>

                    </div>
                </div>

                <div className="col-md-12 mt-4">  </div>



            </div>
            <Footer />
        </>
    )
};

export default SectionDashboard;